import React from "react";

import PropTypes from "prop-types";

import { PageHeader, PageFooter } from "components/organisms";
import { StandardPageTemplate } from "components/templates";
import { Loading } from "components/molecules";

import Sections from "../sections";

import PageSections from "../PageSections";

const Homepage = ({ page }) => {
  if (!page) {
    return <Loading variant="home" />;
  }

  return (
    <StandardPageTemplate
      className="theme--default"
      header={<PageHeader key="PageHeader" itemCount={1} />}
      sections={[
        <PageSections key="PageSections" sections={page.sections} />,
        <Sections.RichSEOSection key="RichSEOSection" />,
      ]}
      footer={<PageFooter key="PageFooter" className="theme--default" />}
    />
  );
};

Homepage.propTypes = {
  // Data response from ".../page?siteType=startpage/..."
  page: PropTypes.shape({}).isRequired,
};

Homepage.defaultProps = {};

export default Homepage;
